import { getYarnValues, getFabricValues } from "./form_data_generator";
import { showNotification } from "./functions";
const required = {
  article: "article",
  collection: "collection",
  "boring-required": ["boring", "no-boring"],
  "repeat-num": "repeat-num",
  "yarn-required": "yarn",
  "fabric-required": "fabric",
  "lr-required": ["L-R", "no-L-R", "pair"],
};
export function requiredFieldsPopulated() {
  let emptyFields = [];
  for (const field of Object.values(required)) {
    if (field === "yarn" || field === "fabric") continue;
    if (isEmpty(field)) {
      emptyFields.push(field);
    }
  }
  if (getYarnValues().length === 0) emptyFields.push("yarn");
  if (getFabricValues().length === 0) emptyFields.push("fabric");
  return emptyFields;
}

function isEmpty(field) {
  if (Array.isArray(field)) {
    return isEmptyArray(field);
  }
  const element = document.getElementById(field);
  if (!element) return true;
  if (element.type === "checkbox") return !element.checked;
  return element.value === "";
}

function isEmptyArray(array) {
  let empty = true;
  for (const field of array) {
    if (!isEmpty(field)) empty = false;
  }
  return empty;
}

export function showErrors(array) {
  for (const key in required) {
    if (!array.includes(required[key])) continue;
    document.querySelector("#" + key).classList.add("error");
  }
  showNotification("error", "Please fill out all required fields.", 10000);
  setTimeout(() => removeErrorMessages(array), 10000);
}

function removeErrorMessages(array) {
  for (const key in required) {
    if (!array.includes(required[key])) continue;
    document.querySelector("#" + key).classList.remove("error");
  }
}
